import React from "react";

/** Shared layout primitives for AdminPage tabs. */
export function Section({ title, children }) {
  return (
    <div className="rounded-xl border border-white/10 bg-white/5 px-4 py-4 space-y-3">
      <div className="text-xs uppercase tracking-widest text-white/40">{title}</div>
      {children}
    </div>
  );
}

export function Field({ label, testid, children }) {
  return (
    <label className="block text-xs text-white/60" data-testid={testid}>
      <div className="mb-1">{label}</div>
      {children}
    </label>
  );
}
